import styled from "styled-components";
import { theme } from "../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../common-deprecated/themes/common";
import * as Button from "../../../../../common-deprecated/styles/v2/toyota/components/Button";

export const SelectGrid = styled.section`
    display: grid;
    gap: ${theme.space[3]}px;
    width: 100%;
    padding: 0 ${theme.space[1]}px;

    @media ${getBreakpoint("only", "md")} {
        padding: 0 48px;
    }

    @media ${getBreakpoint("up", "lg")} {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        padding: 0;
    }
`;

export const Results = styled.div`
    margin-bottom: ${theme.space[3]}px;
    scroll-margin-top: 175px; /* 175px = height of (sticky) navigation header */
    @media ${getBreakpoint("up", "lg")} {
        order: 4;
        grid-column: span 3 / span 3;
        margin-top: ${theme.space[4]}px;
        margin-bottom: 0;
    }
`;

export const ResultsTitle = styled.div`
    display: none;
    @media ${getBreakpoint("up", "lg")} {
        display: block;
        margin-bottom: ${theme.space[3]}px;
    }
`;

export const ModelGrid = styled.section`
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: ${theme.space[3]}px;
    width: 100%;
    @media ${getBreakpoint("up", "sm")} {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: ${theme.space[4]}px;
    }
    @media ${getBreakpoint("up", "lg")} {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: ${theme.space[4]}px;
    }
`;

export const ModelCard = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: ${theme.space[5]}px ${theme.space[3]}px ${theme.space[3]}px;
    border: 1px solid ${theme.colors.grey2};

    ${Button.Primary} {
        margin-top: auto;
    }
`;

export const ModelTitle = styled.div`
    margin-bottom: ${theme.space[1]}px;
    font-family: ${theme.fonts.regular};
    font-size: 2rem;
    text-align: center;
`;

export type SelectCardType = {
    isSelected?: boolean;
};

export const SelectCard = styled.div<SelectCardType>`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${theme.space[4]}px ${theme.space[3]}px ${theme.space[3]}px;
    color: ${({ isSelected }) => (isSelected ? theme.colors.primaryWhite : theme.colors.primaryBlack)};
    background: ${({ isSelected }) => (isSelected ? theme.colors.primaryBlack : theme.colors.grey1)};
    transition: all 0.3s ease-out;

    ${Button.Primary} {
        width: 100%;
    }

    @media ${getBreakpoint("up", "md")} {
        row-gap: ${theme.space[4]}px;
        justify-content: space-between;
        padding: ${theme.space[4]}px ${theme.space[4]}px ${theme.space[4]}px ${theme.space[3]}px;
    }
`;

export const SelectCardTitle = styled.h3`
    margin-bottom: ${theme.space[4]}px;
    font-family: ${theme.fonts.base};
    font-size: 2.2rem;
    line-height: 2.8rem;
    text-align: center;

    @media ${getBreakpoint("up", "md")} {
        margin-bottom: 0;
    }
`;
